import Skeleton from 'react-loading-skeleton';

function IndexBottleOfTheDaySkeleton() {
  return (
    <div className="tw-bg-[#F5F5F5] tw-border tw-border-solid tw-border-custom-gray tw-border-x-0">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-4 tw-py-8">
        <div className="tw-flex tw-flex-col nine:tw-flex-row tw-gap-8 tw-items-stretch">
          {/* Heading for desktop */}
          <div className="tw-hidden max-nine:tw-block">
            <Skeleton height={32} width={250} />
            <div className="tw-mt-1 tw-w-[80%]">
              <Skeleton height={5} />
            </div>
          </div>

          {/* Bottle image - mobile */}
          <div className="nine:tw-hidden tw-bg-white tw-rounded-2xl tw-border tw-border-custom-gray tw-p-6 tw-self-center">
            <Skeleton height={160} width={160} />
          </div>

          {/* Bottle image - desktop */}
          <div className="tw-hidden nine:tw-block tw-bg-white tw-rounded-2xl tw-border tw-border-custom-gray tw-p-[32px_59px]">
            <Skeleton height={281} width={281} />
          </div>

          {/* Right side content */}
          <div className="tw-flex-1 tw-flex tw-flex-col tw-justify-between tw-gap-6">
            <div className="tw-flex tw-flex-col tw-gap-4">
              <Skeleton height={32} width={300} />
              <Skeleton height={20} width={200} />
              <Skeleton height={30} width={150} />
            </div>

            <div className="tw-flex tw-flex-col tw-gap-2">
              <Skeleton height={24} width={100} />
              <Skeleton height={48} width={150} />
            </div>

            {/* Bottom price and button - desktop */}
            <div className="tw-hidden nine:tw-flex tw-items-end tw-justify-between tw-gap-8">
              <div className="tw-bg-[#5F6D7E33] tw-p-4 tw-rounded-xl tw-min-w-48">
                <Skeleton height={20} width={80} />
                <Skeleton height={32} width={100} />
              </div>
              <div className="tw-w-2/4">
                <Skeleton height={48} />
              </div>
            </div>

            {/* Bottom section - mobile */}
            <div className="nine:tw-hidden tw-flex tw-flex-col tw-gap-3">
              <Skeleton height={20} width={100} />
              <Skeleton height={32} width={150} />
              <Skeleton height={48} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndexBottleOfTheDaySkeleton;
